<template>

    <div class="form-horizontal">
        <!--    If is single appointment-->


        <div  v-if="updateAppointments.appointments && updateAppointments.appointments.length === 1" style="margin-bottom: 15px">
            <div class="form-group" >
                <label for="appointment_date" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.choose_datetime') }}</label>
                <div class="col-xs-12 col-md-8 has-feedback" >
                    <Datetime id="appointment_date"
                              :value-zone="TIMEZONE_DEFAULT"
                              :zone="TIMEZONE_DEFAULT"
                              type="datetime"
                              v-model="updateAppointments.appointments[0].date"
                              :phrases="{ok: $t('common.time.choose_datetime'), cancel: $t('common.time.cancel_datetime')}"
                              input-class="form-control"></Datetime>
                    <span class="glyphicon glyphicon-calendar form-control-feedback" aria-hidden="true"></span>
                </div>
            </div>
            <div class="form-group" >
                <label for="client-admin-options" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.associate_user') }}</label>
                <div class="col-xs-12 col-md-8">
                    <select class="form-control" id="client-admin-options" name="client-admin-options" v-model="updateAppointments.appointments[0].chaired_admin.id">
                        <option v-for="clientAdmin in clientsAdminAvailable" v-bind:key="clientAdmin.id" :value="clientAdmin.id">
                            {{clientAdmin.first_name}} {{clientAdmin.last_name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <!--    Else if multiple appointment-->
        <div v-else-if="updateAppointments.appointments && updateAppointments.appointments.length > 1" style="margin-bottom: 15px">
            <div class="form-group" v-for="(appointment, index) in updateAppointments.appointments" v-bind:key="index">
                <label for="appointment_date_multiple" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.update_select_date', {number: (index + 1)}) }}</label>
                <div class="col-xs-12 col-md-8 has-feedback" style="margin-bottom: 5px" >
                    <Datetime id="appointment_date_multiple"
                              :value-zone="TIMEZONE_DEFAULT"
                              :zone="TIMEZONE_DEFAULT"
                              type="datetime"
                              v-model="updateAppointments.appointments[index].date"
                              :phrases="{ok: $t('common.time.choose_datetime'), cancel: $t('common.time.cancel_datetime')}"
                              input-class="form-control"></Datetime>
                    <span class="glyphicon glyphicon-calendar form-control-feedback" aria-hidden="true"></span>
                </div>
                <label for="client-admin-options-multiple" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.update_associate_user', {number: (index + 1)}) }}</label>
                <div class="col-xs-12 col-md-8">
                    <select class="form-control" id="client-admin-options-multiple" name="client-admin-options" v-model="updateAppointments.appointments[index].chaired_admin.id">
                        <option v-for="clientAdmin in clientsAdminAvailable" v-bind:key="clientAdmin.id" :value="clientAdmin.id">
                            {{clientAdmin.first_name}} {{clientAdmin.last_name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label for="location-options" class="col-xs-12 col-md-4 control-label">{{ $t('components.appointment.associate_location') }}</label>
            <div class="col-xs-12 col-md-8">
                <select class="form-control" id="location-options" name="location-options" v-model="updateAppointments.location">
                    <option :value="null">NA</option>
                    <option v-for="location in locationsAvailable" v-bind:key="location.id" :value="location.id">
                        {{location.name}}
                    </option>
                </select>
            </div>
        </div>

        <div class="form-group">
            <label for="appointment_is_online" class="col-xs-12 col-md-4 control-label"></label>
            <div class="col-xs-12 col-md-8">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" id="appointment_is_online" name="appointment_is_online" v-model="updateAppointments.is_online"> {{ $t('components.appointment.appointment_online') }}
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label for="subscription_email_notify" class="col-xs-12 col-md-4 control-label"></label>
            <div class="col-xs-12 col-md-8">
                <div class="checkbox">
                    <label>
                        <input type="checkbox" id="subscription_email_notify" name="subscription_email_notify" v-model="updateAppointments.notify"> {{ $t('common.send_notification_question') }}
                    </label>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {Datetime} from "vue-datetime";
    import 'vue-datetime/dist/vue-datetime.css'
    import {getAllClientAdmin, getAllLocation} from "../../api";
    import {moveUpDatetimePopup} from "@/common/utils";
    import {TIMEZONE_DEFAULT} from "../../common/constants";
    import {StorageHelper} from "../../common/storageHelper";

    // TODO add delete appointment in modal button
    export default {
        name: "UpdateAppointmentModal",
        components: {Datetime},
        props: {
            updateAppointmentsProp: {
                type: Object,
                required: true
            }
        },
        data: () => {
            return {
                TIMEZONE_DEFAULT: StorageHelper.getUser().timezone || TIMEZONE_DEFAULT,
                clientsAdminAvailable: [],
                locationsAvailable: [],
                updateAppointments: {
                }
            }
        },
        async mounted() {
            this.updateAppointments = this.updateAppointmentsProp;
            this.clientsAdminAvailable = await getAllClientAdmin();
            this.locationsAvailable = await getAllLocation();
        },
        watch: {
            updateAppointmentsProp: function(newVal) {
                this.updateAppointments = newVal;
            },
            updateAppointments: {
                handler(newVal) {
                    this.$emit('change', newVal);
                    moveUpDatetimePopup();
                },
                deep: true,
            }
        }
    }
</script>
